<script>
import { Doughnut } from "vue-chartjs";
export default {
  extends: Doughnut,
  props: ["usedApiCalls", "totalPlan", "render"],
  mounted() {
    this.init();
  },
  methods: {
    init() {
      // Overwriting base render method with actual data.
      this.renderChart(
        {
          type: "doughnut",
          labels: ["Used", "To Use"],
          datasets: [
            {
              backgroundColor:
                (this.usedApiCalls / this.totalPlan) * 100 < 70
                  ? [this.$primaryColor, "#E5E7EB"]
                  : (this.usedApiCalls / this.totalPlan) * 100 < 90
                  ? ["#FCD34D", "#E5E7EB"]
                  : ["#EF4444", "#E5E7EB"],
              data:
                (this.usedApiCalls / this.totalPlan) * 100 < 3
                  ? [3, 100]
                  : [this.usedApiCalls, this.totalPlan - this.usedApiCalls],
              labels: ["Used", "To Use"],
              dataLabel: [
                this.usedApiCalls,
                this.totalPlan - this.usedApiCalls,
              ],
            },
          ],
        },
        {
          cutoutPercentage: 70,
          legend: {
            display: false,
          },
          responsive: true,
          maintainAspectRatio: false,
          style: {
            position: "relative",
            height: "80px",
            width: "80px",
            display: "inline-block",
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                var dataSet = data.datasets[tooltipItem.datasetIndex];
                var label = dataSet.labels[tooltipItem.index] || "";

                if (label) {
                  label += ": ";
                }
                label += dataSet.dataLabel[tooltipItem.index];
                return label;
              },
            },
          },
        }
      );
    },
  },
  watch: {
    render() {
      this.init();
    },
  },
};
</script>